const getNestedFromPaths = folders => {
  const nested = {};
  folders.forEach(path =>
    path.split('/').reduce((acc, name) => acc[name] || (acc[name] = {}), nested),
  );
  return nested;
};
export default getNestedFromPaths;
